import React, { useEffect, useMemo, useState } from 'react';
import {useStyles} from "./ArticleSalePrices.style";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useCommonContext } from '../../../../contexts/CommonContext';
import { useI18nContext } from '../../../../contexts/I18nContext';
import ArticleSalePriceStore from './ArticleSalePriceStore';
import { Observer } from 'mobx-react-lite';
import ArticleSalePriceRow from './ArticleSalePricesRow/ArticleSalePriceRow';
import MessageCard from '../../../../ui_components/MessageCard/MessageCard';
import ArticleSalePricesProperties from './ArticleSalePricesProperties';
import FilterInput from '../../../../shared_components/Inputs/FilterInput/FilterInput';
import CopyServicePricesButton from '../../../../shared_components/Buttons/CopyServicePricesButton/CopyServicePricesButton';
import SalePriceItemType from '../../../../entities/SalePriceItemType';
import ButtonType from '../../../../ui_components/Button/ButtonType';
import ButtonSize from '../../../../ui_components/Button/ButtonSize';


const ArticleSalePrices: React.FC<ArticleSalePricesProperties> = ({
    salePrice,
    onUpdate = () => {
    },
}) => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const store = useMemo(() => new ArticleSalePriceStore(commonStore), [commonStore]);
    const classes = useStyles();

    const [inputValue, setInputValue] = useState("");
    const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);

    useEffect(() => {
        store.getArticles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onValueChange = (value: string) => {
        const upperValue = value.toUpperCase();
        setInputValue(upperValue);

        if (debounceTimeout) clearTimeout(debounceTimeout);

        const timeout = setTimeout(() => {
            store.setFilter(upperValue);
        }, 800);

        setDebounceTimeout(timeout);
    };

    return (
        <Observer>
            {() => (
                <div className={classes.article_sale_prices_container}>
                    <div className={classes.tools_container}>
                        <FilterInput
                            value={inputValue}
                            placeholder={i18n.translate("INVENTORY_ITEMS_PLACEHOLDER")}
                            onChange={onValueChange}
                        />
                        <CopyServicePricesButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            sourceSalePriceId={salePrice?.id ?? ''}
                            serviceName={SalePriceItemType.ARTICLE}
                            type={ButtonType.SECONDARY}
                        />
                    </div>
                    {!store.isEmpty &&
                    <div className={classes.article_sale_prices_table}>
                        <div className={classes.elements_container}>
                            {store.articles.map((article, i) => (
                                <ArticleSalePriceRow
                                    onUpdate={onUpdate}
                                    article={article}
                                    salePrice={salePrice}
                                    key={i}
                                />
                            ))}
                        </div>
                    </div>}
                    {store.isEmpty &&
                    <MessageCard icon={CurrencyExchangeIcon} title={i18n.translate("NO_MONEY_SERVICE_FEE_TITLE")}
                                 subtitle={i18n.translate("NO_MONEY_SERVICE_FEE_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default ArticleSalePrices;
